module.exports = [{"id":1,"val":"白"},{"id":2,"val":"绿"},{"id":3,"val":"蓝"},{"id":4,"val":"紫"},{"id":5,"val":"橙"},{"id":6,"val":"红"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/config/emblem_quality.json
// module id = D/0b
// module chunks = 1